import { render, staticRenderFns } from "./weekView.vue?vue&type=template&id=5b22d9a6&"
import script from "./weekView.vue?vue&type=script&lang=js&"
export * from "./weekView.vue?vue&type=script&lang=js&"
import style0 from "./weekView.vue?vue&type=style&index=0&id=5b22d9a6&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports